import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLayout } from '../../components/layout';

const Features: React.FC = () => {
  const features = [
    {
      icon: '📊',
      title: 'إدارة الطلاب',
      description: 'إدارة شاملة لبيانات الطلاب وتتبع تقدمهم الأكاديمي',
      details: [
        'قاعدة بيانات شاملة للطلاب',
        'تتبع الحضور والغياب',
        'متابعة الأداء الأكاديمي',
        'تواصل مباشر مع أولياء الأمور',
      ],
    },
    {
      icon: '📅',
      title: 'جدولة الحصص',
      description: 'نظام متقدم لجدولة الحصص وإدارة الأوقات',
      details: [
        'جدولة تلقائية للحصص',
        'تنبيهات الموعد',
        'إدارة التعارضات',
        'تقويم تفاعلي',
      ],
    },
    {
      icon: '💰',
      title: 'إدارة المدفوعات',
      description: 'نظام دفع آمن ومتكامل لتحصيل الرسوم',
      details: [
        'دفع إلكتروني آمن',
        'تتبع المستحقات',
        'فواتير تلقائية',
        'تقارير مالية شاملة',
      ],
    },
    {
      icon: '📝',
      title: 'الواجبات والاختبارات',
      description: 'إنشاء وإدارة الواجبات والاختبارات بسهولة',
      details: [
        'إنشاء واجبات تفاعلية',
        'تصحيح تلقائي',
        'بنك أسئلة شامل',
        'تحليل النتائج',
      ],
    },
    {
      icon: '📈',
      title: 'التقارير والإحصائيات',
      description: 'تحليلات شاملة لقياس الأداء والنمو',
      details: [
        'تقارير الأداء التفصيلية',
        'إحصائيات الحضور',
        'تحليل المالي',
        'مؤشرات النجاح',
      ],
    },
    {
      icon: '💬',
      title: 'التواصل والإشعارات',
      description: 'نظام تواصل متطور مع الطلاب وأولياء الأمور',
      details: [
        'رسائل WhatsApp تلقائية',
        'إشعارات فورية',
        'تقارير دورية',
        'تنبيهات مخصصة',
      ],
    },
  ];

  return (
    <PublicLayout>
      <div className='bg-gradient-to-br from-primary-50 to-secondary-50 dark:from-secondary-950 dark:to-secondary-900'>
        {/* Hero Section */}
        <div className='bg-gradient-to-r from-primary-600 to-primary-800 text-white py-20 dark:from-secondary-900 dark:to-primary-950'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='text-center'>
              <h1 className='text-4xl md:text-6xl font-bold mb-6'>
                ميزات Class-Tech
              </h1>
              <p className='text-xl text-primary-100 max-w-3xl mx-auto'>
                اكتشف مجموعة شاملة من الأدوات والميزات المصممة خصيصاً لتسهيل
                إدارة أعمالك التعليمية
              </p>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className='py-20'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
              {features.map((feature, index) => (
                <div
                  key={index}
                  className='bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow dark:bg-secondary-900 dark:border dark:border-secondary-800'
                >
                  <div className='text-center mb-6'>
                    <div className='text-4xl mb-4'>{feature.icon}</div>
                    <h3 className='text-xl font-bold text-secondary-900 dark:text-white mb-3'>
                      {feature.title}
                    </h3>
                    <p className='text-gray-600 dark:text-secondary-300'>{feature.description}</p>
                  </div>
                  <ul className='space-y-2'>
                    {feature.details.map((detail, detailIndex) => (
                      <li
                        key={detailIndex}
                        className='flex items-center text-sm text-gray-700 dark:text-secondary-200'
                      >
                        <span className='text-green-500 ml-2'>✓</span>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className='bg-secondary-900 text-white py-20'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center'>
            <h2 className='text-3xl font-bold mb-4'>
              جاهز لتجربة جميع هذه الميزات؟
            </h2>
            <p className='text-lg text-secondary-300 mb-8 max-w-2xl mx-auto'>
              ابدأ تجربتك المجانية اليوم واكتشف كيف يمكن لـ Class-Tech أن يحول
              طريقة إدارتك لأعمالك التعليمية
            </p>
            <div className='flex flex-col sm:flex-row gap-4 justify-center'>
              <Link
                to='/register'
                className='bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors'
              >
                ابدأ التجربة المجانية
              </Link>
              <Link
                to='/contact'
                className='border border-white text-white hover:bg-white hover:text-secondary-900 px-8 py-3 rounded-lg font-semibold transition-all'
              >
                تواصل مع المبيعات
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Features;
